import { combineReducers } from "redux";

import {
  uploadConstants
} from "../../actions/documents/upload";

function isUploadingDocuments(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case uploadConstants.DOCUMENT_UPLOAD_START:
    return true;
  case uploadConstants.DOCUMENT_UPLOAD_SUCCESS:
  case uploadConstants.DOCUMENT_UPLOAD_ERROR:
  case uploadConstants.DOCUMENT_UPLOAD_RESET:
    return false;
  default:
    return defaultState;
  }
}

function isUploadingSingleDocument(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case uploadConstants.SINGLE_DOCUMENT_UPLOAD_START:
    return payload;
  case uploadConstants.DOCUMENT_UPLOAD_START:
  case uploadConstants.DOCUMENT_UPLOAD_SUCCESS:
  case uploadConstants.SINGLE_DOCUMENT_UPLOAD_SUCCESS:
  case uploadConstants.SINGLE_DOCUMENT_UPLOAD_ERROR:
  case uploadConstants.DOCUMENT_UPLOAD_ERROR:
  case uploadConstants.DOCUMENT_UPLOAD_RESET:
    return false;
  default:
    return defaultState;
  }
}

function isErrorUploadingDocument(state, { type, error }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case uploadConstants.DOCUMENT_UPLOAD_ERROR:
    return {
      type: error.numberFiles === error.errorFiles ? "error" : "warning",
      isSo: true,
      errorNumberFiles: error.errorFiles
    };

  case uploadConstants.DOCUMENT_UPLOAD_START:
  case uploadConstants.DOCUMENT_UPLOAD_SUCCESS:
  case uploadConstants.DOCUMENT_UPLOAD_RESET:
    return false;
  default:
    return defaultState;
  }
}

function uploadedSingleDocument(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case uploadConstants.DOCUMENT_UPLOAD_START:
  case uploadConstants.DOCUMENT_UPLOAD_ERROR:
  case uploadConstants.SINGLE_DOCUMENT_UPLOAD_ERROR:
  case uploadConstants.DOCUMENT_UPLOAD_RESET:
    return false;
  case uploadConstants.SINGLE_DOCUMENT_UPLOAD_SUCCESS:
    return {
      status: true,
      documents: payload.filesIds
    };
  default:
    return defaultState;
  }
}

function errorSingleDocument(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case uploadConstants.DOCUMENT_UPLOAD_START:
  case uploadConstants.DOCUMENT_UPLOAD_RESET:
  case uploadConstants.SINGLE_DOCUMENT_UPLOAD_SUCCESS:
  case uploadConstants.SINGLE_DOCUMENT_UPLOAD_START:
    return false;
  case uploadConstants.SINGLE_DOCUMENT_UPLOAD_ERROR:
    return payload;
  default:
    return defaultState;
  }
}

function isUploadFinished(state, { type }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case uploadConstants.DOCUMENT_UPLOAD_START:
  case uploadConstants.DOCUMENT_UPLOAD_RESET:
  case uploadConstants.SINGLE_DOCUMENT_UPLOAD_SUCCESS:
  case uploadConstants.SINGLE_DOCUMENT_UPLOAD_ERROR:
    return false;
  case uploadConstants.DOCUMENT_UPLOAD_SUCCESS:
  case uploadConstants.DOCUMENT_UPLOAD_ERROR:
    return true;
  default:
    return defaultState;
  }
}

function uploadDocumentReset(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case uploadConstants.DOCUMENT_UPLOAD_START:
  case uploadConstants.DOCUMENT_UPLOAD_ERROR:
  case uploadConstants.DOCUMENT_UPLOAD_SUCCESS:
    return false;
  case uploadConstants.DOCUMENT_UPLOAD_RESET:
    return true;
  default:
    return defaultState;
  }
}

export const upload = combineReducers({
  isUploadingDocuments,
  isErrorUploadingDocument,
  isUploadingSingleDocument,
  uploadedSingleDocument,
  errorSingleDocument,
  uploadDocumentReset,
  isUploadFinished
});

export default upload;
